module.exports = __webpack_public_path__ + "img/copy.6c5349bd.svg";